import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import { COUPON_TYPES, PROMO_CODE_DISCOUNT_TYPES } from '../../services/exports/Constants';
import useCashbackProgram from '../cashback/useCashbackProgram';

export default function useDiscounts() {
  const { cached_order } = useSelector((state: StoreInterface) => state.order);

  const { pointsToMoney } = useCashbackProgram();

  const calculateRewardDiscount = () => 0;

  const calculateCashbackDiscount = () => pointsToMoney(cached_order?.cashback_points ?? 0);

  const calculatePromoCodeDiscount = (amount: number) => {
    const couponDetails = cached_order?.coupon_details;
    const activeCoupon = couponDetails?.components?.find((component) => !component.is_used);

    if (!activeCoupon || amount < activeCoupon.usage_threshold) {
      return 0;
    }

    if (couponDetails.discount_type === PROMO_CODE_DISCOUNT_TYPES.FIXED_AMOUNT) {
      return activeCoupon.discount;
    }

    const percentageDiscount = (amount * activeCoupon.discount) / 100;

    // Mirrors the backend's MoneyHelpers::applyPercentageDiscount: any non-null cap limits the
    // discount, so the cart total matches what the order draft charges at checkout.
    return activeCoupon.max_discount == null
      ? percentageDiscount
      : Math.min(percentageDiscount, activeCoupon.max_discount);
  };

  const calculateDiscount = useCallback(
    (amount: number) => {
      const callback =
        {
          [COUPON_TYPES.REWARD]: () => calculateRewardDiscount(),
          [COUPON_TYPES.CASHBACK]: () => calculateCashbackDiscount(),
          [COUPON_TYPES.PROMO_CODE]: () => calculatePromoCodeDiscount(amount),
        }[cached_order?.coupon_type] ?? null;

      return callback ? callback() : 0;
    },
    [cached_order?.coupon_type, cached_order?.coupon_details, cached_order?.cashback_points],
  );

  return {
    calculateDiscount,
  };
}
